import { Injectable, inject } from '@angular/core';
import { SecureStorageService } from './secure-storage.service';
import { BehaviorSubject } from 'rxjs';
import { IBreadCrumb } from '../interfaces/bread-crumb';

@Injectable({
  providedIn: 'root',
})
export class BreadCrumbService {

  private readonly secureStorageService: SecureStorageService = inject(SecureStorageService);
  public migaPan: BehaviorSubject<IBreadCrumb[]> = new BehaviorSubject<IBreadCrumb[]>([]);

  get getBreadCrumb() {
    return this.migaPan.asObservable();
  }

  setBreadCrumb(emptyArray: IBreadCrumb[]) {
    this.migaPan.next(emptyArray);
  }

  getParentsUntilRoot(action: string) {
    
    let menuLocalStorage: string = this.secureStorageService.getData('menus');
    let Data = JSON.parse(menuLocalStorage);
    const parents: { label: string }[] = [];
    let currentItem = Data.find((item: any) => item.action === action);

    function formatText(text: string): string {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    while (currentItem) {
      parents.unshift({ label: formatText(currentItem.text) });
      const parentId = currentItem.menuFatherId;
      currentItem = Data.find((item: any) => item.id === parentId);
    }

    if(parents.length > 0){
      this.migaPan.next(parents);
    }

  }
}
